import styled from 'styled-components';
import { IconButton, Typography } from '@material-ui/core';
import { PlayArrow, Stop } from '@material-ui/icons';
import { FlexDiv } from 'common/flex';

export const Container = styled.div`
    height: 100%;
    margin: 0 25px;
    display: flex;
    flex-direction: column;
    padding: 5px;
    -webkit-app-region: drag;
    overflow-x: hidden;
`;

export const Header = styled.div<{disabled?: boolean}>`
    display: flex;
    flex-direction: column;
    ${({ disabled }) => disabled && `
        pointer-events: none;
        opacity: 0.6;
    `}
`;

export const ActionContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-self: flex-start;
`;

export const TextContainer = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 80px;
`;

export const ActionButton = styled.div`
    flex: 1;
    text-align: center;
    -webkit-app-region: no-drag;
`;

export const PopOutListItem = styled.div<{selected?: boolean}>`
    display: flex;
    flex-direction: row;
    cursor: pointer;
    outline: none;
    background-color: ${({ selected, theme }) => selected ? theme.white.dark : 'transparent'};
    &:focus {
        background-color: ${({ selected, theme }) => selected ? theme.white.dark : theme.white.main};
    }
`;
export const TimerText = styled(Typography)<{selected?: boolean}>`
    flex: 2;
    color: ${props => props.selected && props.theme.secondary.contrastText};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
export const DurText = styled(Typography)<{selected?: boolean}>`
    color: ${props => props.selected && props.theme.secondary.contrastText};
    padding-right: 5px;
    flex-flow: row-reverse;
    && {
        display: flex;
    }
`;

export const SearchContainer = styled.div`
    flex: 1;
    display: flex;
    align-items: flex-end;
    margin-bottom: 5px;
    -webkit-app-region: no-drag;
`;

export const PlayBtn = styled(PlayArrow)`
    color:${props => props.theme.black.light};
    outline: none;
    &:focus {
        background-color: ${props => props.theme.white.main};
    }
`;

export const StopBtn = styled(Stop)`
    outline: none;
    &:focus {
        background-color: ${props => props.theme.white.main};
    }
`;

export const TitleBar = styled.div`
    text-align: right;
`;
export const PopOverContainer = styled.div`
    padding: 8px;
    display: flex;
    flex-direction: column;
    -webkit-app-region: no-drag;
`;

export const FrameBtn = styled(IconButton)`
    -webkit-app-region: no-drag;
`;

export const SaveBtn = styled.div`
    text-align: right;
`
export const MainWrapper = styled(FlexDiv)<{disabled: boolean}>`
    overflow-y: auto;
    -webkit-app-region: no-drag;
    ${({ disabled }) => disabled && `
        pointer-events: none;
        opacity: 0.6;
    `}
`;
export const ListWrapper = styled.div`
    height: 100%;
`;
export const ErrorMessageContainer = styled.div`
    font-size: 14px;
`;